var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducthunt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8376 22.7178C18.3832 22.2905 22.75 17.6552 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75M12.8376 22.7178C12.5612 22.7392 12.2819 22.75 12 22.75M12.8376 22.7178L12 22.75M8.465 17.7995V13.9915M8.465 13.9915V6.2005H12.403C14.6295 6.2005 16.4345 7.9445 16.4345 10.0955C16.4345 12.2465 14.6295 13.9915 12.403 13.9915H8.465Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducthunt);
export default __webpack_public_path__ + "static/media/producthunt.b42522cec9142b25d0bc2eec3ddda13e.svg";
export { ForwardRef as ReactComponent };